import React from 'react';
import {
  Typography,
  Button,
  Box,
  Paper,
  makeStyles,
  Theme,
} from '@material-ui/core';
import EmergencyHomeIcon from '../../../../static/redWarning.svg';
import { useTranslation } from '../../../../hooks/useTranslation';
import PhoneButtonIcon from '../../../../static/PhoneOutageIcon.svg';
import colors from '../../../../themes/main-colors';
import ReactMarkdown from 'react-markdown/with-html';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: 20,
  },
  box: {
    textAlign: 'center' as const,
  },
  icon: {
    fontSize: 48,
    marginBottom: 16,
  },
  title: {
    marginBottom: 16,
    fontSize: 24,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  subContent: {
    marginBottom: 25,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  content: {
    marginBottom: 12,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  savePreferencesButton: {
    borderRadius: 25,
    color: colors.white,
    fontSize: 18,
    width: '50%',
    padding: '8px 0px',
    background: colors.orange,
    '&:hover': {
      backgroundColor: colors.orange,
      borderColor: colors.orange,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  phoneIcon: {
    marginRight: 8,
  },
  customerCareNumber: {
    '& p': {
      margin: 0,
    },
    '& a': {
      color: colors.white,
      textDecoration: 'none',
    },
  },
}));

interface Props {
  orangeButton?: boolean;
}

const DimOrFlickeringComp: React.FC<Props> = ({ orangeButton }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.paper}>
      <Box className={classes.box}>
        <EmergencyHomeIcon className={classes.icon} />
        <Typography className={classes.title}>
          {t('SAFETY_TOP_PRIORITY')}
        </Typography>
      </Box>
      <Typography className={classes.content}>
        {t('DIM_FLICKERING_CONTENT')}
      </Typography>
      <Typography className={classes.subContent}>
        {t('DIM_FLICKERING_SUBCONTENT')}
      </Typography>

      {orangeButton && (
        <div style={{ textAlign: 'center' }}>
          <Button className={classes.savePreferencesButton} onClick={() => ''}>
            <PhoneButtonIcon className={classes.phoneIcon} />
            <ReactMarkdown
              source={t('CUSTOMER_CARE_NUMBER_PORTLAND_NEW')}
              escapeHtml={false}
              className={classes.customerCareNumber}
            />
          </Button>
        </div>
      )}
    </Paper>
  );
};

export default DimOrFlickeringComp;
